// extracted by mini-css-extract-plugin
export default {"Snackbar":"SnackBarAlert_Snackbar__jJtv1","viewNotification":"SnackBarAlert_viewNotification__u++b0","closeBanner":"SnackBarAlert_closeBanner__6eQUT"};